import HandleQuestionnaireActions from './HandleQuestionnaireActions';

export default HandleQuestionnaireActions;